import React from 'react'
import clsx from 'clsx'

import Search from '../../Search'

import useStyles from './styles'

type BottomRowComponentProps = {
  onSearch?: (s: string) => void
  fullWidth?: boolean
  isSmall?: boolean
  children: React.ReactNode
  preChildren?: React.ReactNode
  searchChildren?: React.ReactNode
  searchVal?: string
  className?: string
}

const BottomRowComponent: React.FC<BottomRowComponentProps> = ({
  onSearch,
  fullWidth,
  children,
  isSmall,
  preChildren,
  searchChildren,
  searchVal,
  className
}) => {
  const classes = useStyles()

  return (
    <div
      className={clsx(
        classes.root,
        isSmall && classes.smallRoot,
        'bottomRow',
        className
      )}
    >
      {preChildren && <div className='preChildren'>{preChildren}</div>}

      {onSearch && (
        <Search
          searchVal={searchVal}
          onSearch={onSearch}
          fullWidth={fullWidth}
          children={searchChildren}
        />
      )}

      <div className='children'>{children}</div>
    </div>
  )
}

export default React.memo(BottomRowComponent)
